"use client";

import Link from "next/link";
import type { ReactNode } from "react";
import { useLegal } from "@/components/legal/legal-provider/legal-context";
import { LEGAL_DOCUMENTS, type LegalDocumentId } from "@/lib/legal/documents";

/**
 * A real link to the policy page that opens the policy in a modal instead.
 * Modified clicks (new tab, new window) keep the browser's behaviour.
 */
export function LegalLink({
  doc,
  className,
  children,
}: {
  doc: LegalDocumentId;
  className?: string;
  children: ReactNode;
}) {
  const legal = useLegal();

  return (
    <Link
      href={LEGAL_DOCUMENTS[doc].href}
      prefetch={false}
      className={className}
      onClick={(event) => {
        if (!legal || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        legal.openDocument(doc);
      }}
    >
      {children}
    </Link>
  );
}

/** Reopens the cookie preferences, as the Garante requires to be always possible. */
export function CookieSettingsButton({
  className,
  children = "Preferenze cookie",
}: {
  className?: string;
  children?: ReactNode;
}) {
  const legal = useLegal();

  return (
    <button type="button" className={className} onClick={() => legal?.openCookiePreferences()}>
      {children}
    </button>
  );
}
